import v1error from './v1error'
import v1errors from './v1errors'

export default {
  v1error,
  v1errors,
}
